import * as React from 'react';

class OrderTerms extends React.PureComponent {
    public render(): JSX.Element {
        return (
            <>
                <div className="popup-title">Terms and conditions</div>
                <div className="popup-text">
                    The buyer accepts the order, shipment and payment terms consented on in the signed agreement between the buyer and the
                    seller (Happy Socks AB).
                </div>
            </>
        );
    }
}

export default OrderTerms;



// WEBPACK FOOTER //
// ./src/view/OrderTerms.tsx